<template>
    <div class="card">
        <Toast />
        <form>
            <div class="p-grid p-fluid">
                <div class="p-col-12">
                    <h5>{{ $t('notification.Add.Add New Notification') }}</h5>
                    <div class="p-grid p-formgrid p-mb-3">
                        <div class="p-col-12 p-mb-2 p-lg-5 p-mb-lg-0 p-field">
                            <label for="title2">{{ $t('notification.Add.Notification Type') }}</label>
                            <Dropdown :class="`${error.notification_type ? 'p-invalid' : ''}`" v-model="notification_type" :options="notificationtype" optionValue="code" optionLabel="name" placeholder="하나를 선택하세요" />
                            <!-- <Dropdown id="state" v-model="notification_type" :options="notificationtype" optionLabel="name" placeholder="하나를 선택하세요"></Dropdown> -->
                            <div class="text-red">{{ error.notification_type }}</div>
                        </div>
                    </div>
                    <div class="p-grid p-formgrid p-mb-3">
                        <div class="p-col-12 p-mb-2 p-lg-5 p-mb-lg-0 p-field">
                            <label for="title2">{{ $t('notification.Add.Notification Title') }}</label>
                            <InputText type="text" :class="`${error.notification_title ? 'p-invalid' : ''}`" placeholder="알림 제목 입력" id="title2" v-model="notification_title"></InputText>
                            <div class="text-red">{{ error.notification_title }}</div>
                        </div>
                    </div>
                    <div class="p-grid p-formgrid p-mb-3">
                        <div class="p-field p-col-12 p-md-5">
                            <label for="title2">{{ $t('notification.Add.Description') }}</label>
                            <Textarea type="text" :class="`${error.description ? 'p-invalid' : ''}`" :placeholder="$t('설명 입력')" id="title2" v-model="description"></Textarea>
                            <div class="text-red">{{ error.description }}</div>
                        </div>
                    </div>

                    <div class="p-grid p-formgrid p-mb-3">
                        <div class="p-col-12 p-mb-2 p-lg-5 p-mb-lg-0 p-field">
                            <label for="subtitle2">
                                {{ $t('notification.Add.Upload Coupon Image') }}
                                <!-- <span class="img-info">(File Type jpg,jpeg,png )</span> -->
                            </label>
                            <div :class="`${error.file ? 'custom-select-invalid' : 'custom-select'}`">
                                <span v-if="!fileName">파일 선택</span>
                                <span v-else>{{ fileName }}</span>
                                <input type="file" class="select-file" v-on:change="onFileChange" />
                                <Button :label="$t('button.select_file')" class="SelectBtn n-wrap" />
                            </div>
                            <span class="img-info">Maximum accepted file Size will be 5mb for "jpg","png","jpeg",pdf file types</span>
                            <div class="text-red">{{ error.file }}</div>
                            <div class="text-red" v-show="render1">{{ $t('validation.invalidFile') }}</div>
                            <img id="frame" src width="100px" height="100px" />
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="p-d-flex p-jc-between p-mb-2">
                    <div>
                        <h5>{{ $t('notification.Add.Select recipient(s)') }}</h5>
                    </div>
                    <div>
                        <div class="p-field p-col-10 p-md-2" style="padding: 0">
                            <InputText id="nameuser" v-model="nickname" type="text" placeholder="유저 ID 혹은 닉네임검색" style="width: 80px" @change="searchnotification" />
                        </div>
                    </div>
                    <div>
                        <div class="p-field p-col-10 p-md-2" style="padding: 0; margin-left: 5px">
                            <InputText id="minid" v-model="min_point" type="text" placeholder="최소포인트" onkeypress="return /[0-9]/i.test(event.key)" style="width: 80px" @change="searchnotification" />
                        </div>
                    </div>
                    <div>
                        <div class="p-field p-col-10 p-md-2" style="padding: 0; margin-left: 5px">
                            <InputText id="maxid" v-model="max_point" type="text" placeholder="최대포인트" onkeypress="return /[0-9]/i.test(event.key)" style="width: 80px" @change="searchnotification" />
                        </div>
                    </div>
                    <div>
                        <div class="p-field p-col-10 p-md-2" style="padding: 0; margin-left: 5px">
                            <Dropdown v-model="gender" :options="genders" optionLabel="name" placeholder="성별" @change="searchnotification" />
                        </div>
                    </div>
                    <div>
                        <div class="p-field p-col-10 p-md-2" style="padding: 0; margin-left: 5px">
                            <Dropdown id="AgeGroup" v-model="age_group" :options="age_groups" optionLabel="name" placeholder="연령대" @change="searchnotification"></Dropdown>
                        </div>
                    </div>
                    <div>
                        <div class="p-field p-col-10 p-md-2" style="padding: 0; margin-left: 5px">
                            <Dropdown id="MaritalStatus" v-model="marital_status" :options="marital_statuss" optionLabel="name" placeholder="혼인여부" @change="searchnotification"></Dropdown>
                        </div>
                    </div>
                    <div>
                        <div class="p-field p-col-10 p-md-2" style="padding: 0; margin-left: 5px">
                            <Dropdown id="Children" v-model="has_children" :options="children" optionLabel="name" placeholder="자녀여부" @change="searchnotification"></Dropdown>
                        </div>
                    </div>
                    <div>
                        <div class="p-field p-col-10 p-md-2" style="padding: 0; margin-left: 5px">
                            <MultiSelect v-model="children_age" :options="c_ages" optionLabel="name" placeholder="자녀연령대" @change="helloqwe" />
                            <!-- <Dropdown v-model="children_age" :options="c_ages" optionLabel="name" placeholder="자녀연령대" @change="searchnotification"></Dropdown> -->
                        </div>
                    </div>
                    <div>
                        <div class="p-field p-col-10 p-md-2" style="padding: 0; margin-left: 5px">
                            <Dropdown id="AccountStatus" v-model="status" :options="account_statuss" optionLabel="name" placeholder="계정상태" @change="searchnotification"></Dropdown>
                        </div>
                    </div>
                    <div>
                        <div class="p-field p-col-10 p-md-2" style="padding: 0; margin-left: 5px">
                            <Dropdown id="Pets" v-model="has_pet" :options="pets" optionLabel="name" placeholder="반려동물타입" @change="searchnotification"></Dropdown>
                        </div>
                    </div>
                    <!-- <div>
                        <div class="p-field p-col-10 p-md-2" style="padding: 0; margin-left: 5px">
                        
                        <Dropdown id="Pettype" v-model="pet_type" :options="pets_type" optionLabel="name" placeholder="반려동물 여부" @change="searchnotification"></Dropdown>
                        </div>
                    </div> -->
                </div>
                <DataTable :value="customer1" :paginator="true" class="p-datatable-gridlines" :rows="10" dataKey="id" :rowHover="true" :loading="loading1" :filters="filters1" responsiveLayout="scroll" v-model:selection="selected">
                    <!-- v-model:selection="selected" -->
                    <ConfirmDialog group="dialog" />

                    <template #empty> No Data found. </template>
                    <template #loading> Loading data. Please wait. </template>

                    <!-- <column selectionMode="multiple" style="width: 16px; text-align: center" /> -->
                    <!-- <Column field="slNO" :header="$t('#')" style="min-width: 12rem">
                        <template #body="{ index }">
                            <span class="p-column-title">slNo</span>
                            {{ index + 1 }}
                        </template>
                    </Column> -->
                    <column selectionMode="multiple" style="width: 16px; text-align: center" />
                    <Column field="name" header="닉네임" style="min-width: 12rem">
                        <template #body="{ data }">
                            <span class="p-column-title">Nickname</span>
                            {{ data.nickname }}
                        </template>
                    </Column>
                    <Column header="ID" style="min-width: 12rem">
                        <template #body="{ data }">
                            <span class="p-column-title">Id</span>
                            {{ data.username }}
                        </template>
                    </Column>
                    <Column header="Point" style="min-width: 12rem">
                        <template #body="{ data }">
                            <span class="p-column-title">Point</span>
                            {{ data.points }}
                        </template>
                    </Column>
                    <Column header="성별" style="min-width: 12rem">
                        <template #body="{ data }">
                            <span class="p-column-title">Gender</span>
                            {{ data.gender }}
                        </template>
                    </Column>
                    <Column header="연령대" style="min-width: 12rem">
                        <template #body="{ data }">
                            <span class="p-column-title">Age Group</span>
                            {{ data.age_group }}
                        </template>
                    </Column>
                    <Column header="혼인여부" style="min-width: 12rem">
                        <template #body="{ data }">
                            <span class="p-column-title">Marital Status</span>
                            {{ data.married == 1 ? 'Married' : 'Unmarried' }}
                        </template>
                    </Column>
                    <Column header="자녀여부" style="min-width: 12rem">
                        <template #body="{ data }">
                            <span class="p-column-title">Children</span>
                            {{ data.has_children == 1 ? 'Yes' : 'No' }}
                        </template>
                    </Column>
                    <Column header="자녀연령대" style="min-width: 12rem">
                        <template #body="{ data }">
                            <span class="p-column-title">Children Age</span>
                            {{ $t(data.children_age == null ? '-' : data.children_age) }}
                        </template>
                    </Column>
                    <Column header="반려동물여부" style="min-width: 12rem">
                        <template #body="{ data }">
                            <span class="p-column-title">Pets</span>
                            {{ data.has_pets == 1 ? 'Yes' : 'No' }}
                        </template>
                    </Column>
                    <Column header="반려동물타입" style="min-width: 12rem">
                        <template #body="{ data }">
                            <span class="p-column-title">Pets Type</span>
                            {{ $t(data.pet_type == null ? '-' : data.pet_type) }}
                        </template>
                    </Column>
                    <Column header="계정상태" style="min-width: 12rem">
                        <template #body="{ data }">
                            <span class="p-column-title">Account Status</span>
                            {{ $t(data.status) }}
                        </template>
                    </Column>
                </DataTable>
            </div>

            <div class="p-d-flex p-jc-end p-ai-center" style="float: left">
                <Button :label="$t('Save')" iconPos="left" class="p-button p-button-sm p-mr-2 p-mb-2" @click="addNotification"></Button>
            </div>
            <div class="p-d-flex p-jc-end p-ai-center">
                <div>
                    <Button :label="$t('Back')" iconPos="left" class="p-button p-button-outlined p-button-sm p-mr-2 p-mb-2" @click="$router.go(-1)"></Button>
                    <!-- <Button :label="$t('Confirm')" icon="pi pi-check" iconPos="left" class="p-button p-button-sm p-mr-2 p-mb-2"></Button> -->
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import axios from 'axios';
import NotificationService from '../../service/API/NotificationService';
import UserService from '../../service/API/UserService';
import validateCreateNotification from '../../validations/notification/validateCreateNotification';
export default {
    name: 'addnotification',
    data() {
        return {
            selected: [],
            selectedItemss: '',
            render: true,
            display: false,
            position: 'center',
            visibleLeft: false,
            visibleRight: false,
            visibleTop: false,
            visibleBottom: false,
            visibleFull: false,

            customer1: null,
            loading1: true,
            idFrozen: false,
            products: null,
            expandedRows: [],
            user: null,
            files: null,
            filesName: '',
            file: '',
            image: '',
            fileName: '',
            fileExtension: '',
            filesExtension: '',
            statuses: ['unqualified', 'qualified', 'new', 'negotiation', 'renewal', 'proposal'],
            nickname: '',
            username: '',
            min_point: '',
            max_point: '',
            gender: '',
            age_group: '',
            marital_status: '',
            notification_type: '',
            notification_title:'',
            description: '',
            has_children: '',
            children_age: '',
            has_pet: '',
            pet_type: '',
            status: '',
            married: '',

            notificationtype: [
                // { name: 'Statistical', code: 'statistical' },
                // { name: 'Coupon', code: 'coupon' },
                // { name: 'Survey reminder', code: 'survey_reminder' },
                { name: 'Manual', code: 'manual' },
            ],
            genders: [
                { name: 'Female', code: 'female' },
                { name: 'Male', code: 'male' },
            ],
            pets: [
                { name: 'Yes', code: '1' },
                { name: 'No', code: '0' },
            ],
            pets_type: [
                { name: 'Cat', code: 'CAT' },
                { name: 'Puppy', code: 'PUPPY' },
                { name: 'Etc', code: 'ETC' },
            ],
            children: [
                { name: 'Yes', code: '1' },
                { name: 'No', code: '0' },
            ],
            // children_agedropdown: [
            //     { name: 'Infant', code: '10_20' },
            //     { name: 'Adult', code: '21_30' },
            //     { name: 'School Age', code: '31_40' },
            // ],
            // c_ages: [
            //     { name: 'INFANT', code: '10_20' },
            //     { name: 'ADULT', code: '21_30' },
            //     { name: 'SCHOOL_AGED_CHILDREN', code: '31_40' },
            // ],
            c_ages: [{ name: 'INFANT' }, { name: 'ADULT' }, { name: 'SCHOOL_AGED_CHILDREN' }],
            marital_statuss: [
                { name: 'Married', code: '1' },
                { name: 'Unmarried', code: '0' },
            ],
            account_statuss: [
                { name: 'Active', code: 'active' },
                { name: 'Inactive', code: 'inactive' },
            ],
            age_groups: [
                { name: '25 ~ 35', code: '25 ~ 35' },
                { name: '36 ~ 45', code: '36 ~ 45' },
                { name: '46 ~ 55', code: '46 ~ 55' },
                { name: '56 ~ 65', code: '56 ~ 65' },
            ],
            formData: new FormData(),
            dropdownItem: null,
            error: {},
            //params for list
            Ntitle: '',
            Ntype: '',
            start_date: '',
            end_date: '',
        };
    },
    customerService: null,
    productService: null,
    created() {
        this.notificationService = new NotificationService();
        this.userService = new UserService();
    },
    mounted() {
        this.getlist();
    },
    methods: {
        helloqwe() {
            let xyz = [];
            let data = this.children_age;
            for (var a = 0; a < data.length; a++) {
                xyz.push(data[a].name);
            }
            // xyz.push(data);
            // this.selectedItemss = xyz.toString();
            this.selectedItemss = xyz;
            console.log(this.children_age);
            console.log(this.selectedItemss);
            this.getlist();
        },
        getlist() {
            console.log(this.selectedItemss);
            this.userService
                .getUserList(this.nickname, this.username, this.has_children.code, this.selectedItemss, this.gender.code, this.age_group.code, this.marital_status.code==''?'':this.marital_status.code,this.status.code, this.has_pet.code==''?'': this.has_pet.code, this.min_point, this.max_point, this.start_date==""?"":this.formatDate(this.start_date), this.end_date==""?"":this.formatDate(this.end_date))

                .then((data) => {
                    this.customer1 = data;
                    this.loading1 = false;
                    this.customer1.forEach((customer) => (customer.createdDate = new Date(customer.createdDate)));
                });
        },
        reinitialize() {
            (this.dropdownValue = null), (this.dropdownValueType = null), (this.title = null), (this.subtitle = null), (this.link = null), (this.fileName = null), (this.file = {});
        },
        searchnotification() {
            this.getlist();
        },

       
        onFileChange(e) {
             this.formData.delete('file');
            var files = e.target.files || e.dataTransfer.files;
            if (!files.length) return;
            this.file = files[0];
            var allowedExtensions = /(\.jpg|\.jpeg|\.png|\.pdf)$/i;
            if (!allowedExtensions.exec(this.file.name)) {
                this.render1 = true;
                return false;
            } else {
                this.render1 = false;
                this.fileName = this.file.name;
                console.log(this.file.name);
                this.formData.append('image', files[0]);
            }
            this.fileExtension = this.fileName.replace(/^.*\./, '');
            console.log(this.fileName);
        },
        formatDate(value) {
            const date = new Date(value);
            var dd = date.getDate();
            var mm = date.getMonth() + 1;
            var yyyy = date.getFullYear();
            var hr = date.getHours();
            var min = date.getMinutes();
            var sec = date.getSeconds();
            if (dd < 10) {
                dd = '0' + dd;
            }
            if (mm < 10) {
                mm = '0' + mm;
            }
            return (value = `${yyyy}-${mm}-${dd} ${hr}:${min}:${sec}`);
        },
        addNotification() {
            let xyz = [];
            let data = this.selected;
            let self = this;
            this.formData.delete('notification_title');
            this.formData.delete('description');
            this.formData.delete('notification_type');
            
            for (var a = 0; a < data.length; a++) {
                //    xyz.push({ user_id: data[a].id });
                
                xyz.push(data[a].id);
            }
            if(xyz.length == 0){
                self.$toast.add({ severity: 'error', summary: 'error', detail: '한 명 이상의 사용자를 선택하세요.', life: 3000 });
                // alert('한 명 이상의 사용자를 선택하세요.');
                setTimeout(() => {
                        // window.location.reload();
                    }, 1000);
                
            }

            console.log(xyz);
            self.selectedItemss = xyz;
            let vcheckData = {
                notification_title: self.notification_title,
                description: self.description,
                notification_type: self.notification_type,
                user_ids_arr: xyz,
                file: self.fileName == '' ? '' : 'something',
            };
            //    this.formData.delete('notification_title');
            //     this.formData.delete('description');
            //     this.formData.delete('notification_type');
            //     this.formData.delete('user_ids_arr');
            const { isInvalid, error } = validateCreateNotification(vcheckData);
            if (isInvalid) {
                self.error = error;
                console.log(error);
            } else {
                console.log(self.notification_type);
                self.formData.append('notification_title', self.notification_title);
                self.formData.append('description', self.description);
                self.formData.append('notification_type', self.notification_type);
 
                
                for (const a of xyz) {
                    self.formData.append('user_ids_arr[]', a);
                }
                // this.formData.append('user_ids_arr', JSON.stringify(xyz));
                // this.formData.append('start_date', this.formatDate(this.start_date));
                // this.formData.append('end_date', this.formatDate(this.end_date));
                // this.formData.append('status', this.status == '' ? 'inactive' : 'active');
                console.log(self.notification_type);
                return axios.post('/notification', this.formData).then(() => {
                    // alert('알림이 성공적으로 추가되었습니다.');

                    self.$toast.add({ severity: 'info', summary: '확인.', detail: '알림이 성공적으로 추가되었습니다.', life: 3000 });
                    setTimeout(() => {
                       self.$router.push({ name: 'NotificationList' }); 
                    }, 1000);
                    
                });
            }
        },
    },
};
</script>

<style scoped>
.img-info {
    font-size: 11px;
    font-weight: 400;
    color: rgb(48, 48, 48);
}
.custom-select {
    position: relative;
    border: 1px solid #cecece;
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 15px;
}
.custom-select-invalid {
    position: relative;
    border: 1px solid red;
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 15px;
}
.select-file {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0%;
    z-index: 5;
    opacity: 0;
}
.SelectBtn {
    max-width: 100px;
}
.custom-select span {
    max-width: 140px;
    display: inline-block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
</style>